import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { TechniqueDescribedPage } from './technique-described.page';

const routes: Routes = [
  {
    path: '',
    component: TechniqueDescribedPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [TechniqueDescribedPage]
})
export class TechniqueDescribedPageModule {}
